module.exports = __webpack_public_path__ + "static/media/logoFooter.03a01a32.png";